import {FC, useEffect} from 'react'
import {useAuth} from '../../auth'
import {isOnPremisesInstallation} from '../../auth/core/onPremisesAccess'
import {syncPushSubscription} from '../core/webPush'

/**
 * Mounted once in the panel layout: a browser that turned web push on earlier is saved again for
 * the user signed in now, without asking anything. Never in a support session — the operator's
 * browser must not receive the customer's notifications — and never on an on-premises install,
 * which has no notification centre.
 */
export const WebPushSync: FC = () => {
  const {currentUser} = useAuth()
  const userId = Number(currentUser?.id || 0)
  const support = Boolean(currentUser?.support)
  const onPremises = isOnPremisesInstallation(currentUser)

  useEffect(() => {
    if (!userId || support || onPremises) return
    syncPushSubscription().catch(() => undefined)
  }, [userId, support, onPremises])

  return null
}
